import { PluginKey } from 'prosemirror-state';

import { EditorView } from '@lyearn/lygo-core';

import { setPluginMeta } from '../../utils';
import { AdvancedMenuItemProps } from './types';

export const AdvancedMenuPluginKey = new PluginKey('advanced-menu-items-key');

export const addAdvanceMenuItem = (
  editorView: EditorView,
  advancedMenuItem: AdvancedMenuItemProps,
) => {
  if (!editorView.editable) {
    return;
  }
  const state = AdvancedMenuPluginKey.getState(editorView.state);
  const advancedMenuItemsMap = state?.advancedMenuItemsMap;

  if (advancedMenuItemsMap) {
    const newState = {
      ...state,
      advancedMenuItemsMap: advancedMenuItemsMap.set(advancedMenuItem.name, advancedMenuItem),
    };
    editorView.dispatch(editorView.state.tr.setMeta(AdvancedMenuPluginKey, newState));
  }
};

export const hideAdvancedMenu = (view: EditorView) => {
  const prevProps = AdvancedMenuPluginKey.getState(view.state);
  if (prevProps?.open) {
    const props = {
      open: false,
    };

    setPluginMeta(view, AdvancedMenuPluginKey, { ...prevProps, ...props });
  }
};
